import { Component } from '@angular/core';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'mobile-security-info',
	template: require('./mobile-security-info.component.html'),
	host: { class: 'flex-column ' },
})
export class MobileSecurityInfoComponent {
	public isRebrading = AppSettings.isRebrading;
}
